import React from 'react'

import styled, { CSS } from 'styled-components'

import { Icon, IconEnum, Paragraph, Spacer } from '@client/components'
import { DisabledEffect, ResponsivePXValue, theme, ZeroSpace } from '@components/Theme'

const Container = styled.div<{ $background?: string, $disabled?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: fit-content;
  border-radius: 6px;

  background-color: ${(props): string => props.$background ? props.$background : props.theme.colors.whites.pureWhite};

  ${(props): CSS => props.$disabled ? DisabledEffect : undefined};

  ${ResponsivePXValue('padding', '3px 8px')}

  .title {
    ${ZeroSpace}
  }

  &.filter-pill {
    ${ResponsivePXValue('padding-top', { mobile: '7px', tablet: '7px', desktop: '7px' })}
    ${ResponsivePXValue('padding-bottom', { mobile: '3px', tablet: '3px', desktop: '3px' })}
    
    .icon-container {
      ${ResponsivePXValue('margin-top', { mobile: '-2px', tablet: '-2px', desktop: '-3px' })}
    }
  }
  
  &.flex-pill {
    ${ResponsivePXValue('padding-top', { mobile: '3px', tablet: '3px', desktop: '5px' })}
    ${ResponsivePXValue('padding-bottom', { mobile: '3px', tablet: '3px', desktop: '0px' })}
    ${ResponsivePXValue('padding-left', '8px')}
    ${ResponsivePXValue('padding-right', '8px')}
    
    .title {
      ${ResponsivePXValue('line-height', { mobile: '20px', tablet: '20px', desktop: '18px' })}
      margin: 0;
      padding: 0;
    }
  }
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${ResponsivePXValue('width', '14px')}
  ${ResponsivePXValue('height', '14px')}
`

export interface PillProps {
  title: string
  backgroundColor?: string
  textColor?: string
  className?: string
  iconClassName?: string
  iconColor?: string
  closable?: boolean
  disabled?: boolean
  isMini?: boolean
  onClick?: () => void
  onClose?: () => void
}

export function Pill({
  title,
  backgroundColor,
  textColor = theme.colors.whites.pureWhite,
  className,
  iconClassName,
  iconColor = theme.colors.whites.pureWhite,
  closable = false,
  disabled = false,
  isMini = false,
  onClick,
  onClose,
}: PillProps): JSX.Element {

  const _handleOnClick = (): void => {
    if (!disabled && onClick) {
      onClick()
    }
  }

  const _handleOnClose = (): void => {
    if (!disabled && onClose) {
      onClose()
    }
  }

  return (
    <Container className={className} $background={backgroundColor} $disabled={disabled} onClick={_handleOnClick}>

      <Choose>
        <When condition={isMini}>
          <Paragraph variant='p3' color={textColor} className='title'>{title}</Paragraph>
        </When>
        <Otherwise>
          <Paragraph variant='p2' color={textColor} className='title' bold>{title}</Paragraph>

        </Otherwise>
      </Choose>
      <If condition={closable}>
        <Spacer universal='12px' variant='horizontal' />
        <IconContainer className='icon-container' onClick={_handleOnClose}>
          <Icon className={iconClassName} icon={IconEnum.CLOSE_OUTLINE} color={iconColor} />
        </IconContainer>
      </If>
    </Container>
  )
}
